// Vendor Libraries
import { EventEmitter } from '@angular/core';
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../charts/static/charts/ts/features/bar-chart/bar-chart.component";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i4 from "../../../module-upsell/module-upsell.component";
import * as i5 from "../attribution-relative-zoom-controls/attribution-relative-zoom-controls.component";
const _c0 = a0 => ({ "min-height-220": a0 });
function AttributionBarChartComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function AttributionBarChartComponent_div_10_ycn_loading_symbol_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 15);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function AttributionBarChartComponent_div_10_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const idx_r3 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-legend-item-title bullet-", idx_r3 + 1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(category_r2.name);
} }
function AttributionBarChartComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "div", 18)(3, "div", 19);
    i0.ɵɵtemplate(4, AttributionBarChartComponent_div_10_div_2_div_4_Template, 3, 4, "div", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 21)(6, "div", 22);
    i0.ɵɵelement(7, "ycn-bar-chart", 23);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.categories);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("chartData", ctx_r0.categories);
} }
function AttributionBarChartComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, AttributionBarChartComponent_div_10_ycn_loading_symbol_1_Template, 1, 1, "ycn-loading-symbol", 13)(2, AttributionBarChartComponent_div_10_div_2_Template, 8, 2, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loading);
} }
export class AttributionBarChartComponent {
    constructor() {
        this.errorMessage = '';
        this.asOfDateOption = '';
        this.periodicityChangeHandler = new EventEmitter();
    }
    updatePeriodicity(periodicity) {
        this.periodicityChangeHandler.emit(periodicity);
    }
}
AttributionBarChartComponent.ɵfac = function AttributionBarChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionBarChartComponent)(); };
AttributionBarChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionBarChartComponent, selectors: [["ycn-attribution-bar-chart"]], inputs: { performancePeriodicity: "performancePeriodicity", categories: "categories", loading: "loading", errorMessage: "errorMessage", asOfDateOption: "asOfDateOption" }, outputs: { periodicityChangeHandler: "periodicityChangeHandler" }, standalone: false, decls: 11, vars: 8, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [3, "periodicityChangeHandler", "performancePeriodicity", "asOfDateOption"], [1, "panel-content", 3, "ngClass"], [3, "title"], ["class", "toast toast-error", 4, "ngIf"], ["class", "chart-cover", 4, "ngIf"], [1, "toast", "toast-error"], [1, "toast-text"], [1, "chart-cover"], [3, "loaderMessage", 4, "ngIf"], ["class", "chart-interactive", 4, "ngIf"], [3, "loaderMessage"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-options"], [1, "chart-legend"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-wrap"], [1, "chart-canvas", 2, "height", "400px"], [3, "chartData"], [1, "chart-legend-item"]], template: function AttributionBarChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Attribution Bar Chart");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "ycn-attribution-relative-zoom-controls", 5);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionBarChartComponent_Template_ycn_attribution_relative_zoom_controls_periodicityChangeHandler_6_listener($event) { return ctx.updatePeriodicity($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelement(8, "ycn-module-upsell", 7);
        i0.ɵɵtemplate(9, AttributionBarChartComponent_div_9_Template, 3, 1, "div", 8)(10, AttributionBarChartComponent_div_10_Template, 3, 2, "div", 9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("performancePeriodicity", ctx.performancePeriodicity)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx.errorMessage));
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", "Attribution Bar Chart");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.errorMessage);
    } }, dependencies: [i1.BarChartComponent, i2.NgClass, i2.NgForOf, i2.NgIf, i3.LoadingSymbolComponent, i4.ModuleUpsellComponent, i5.AttributionRelativeZoomControlsComponent], encapsulation: 2 });
